import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { RutFormat, formatRut } from '@fdograph/rut-utilities';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject, debounceTime } from 'rxjs';
import { Clients } from 'src/app/models/interfaces/clients';
import { Reservations } from 'src/app/models/interfaces/reservations';
import { ApiSearchService } from 'src/app/modules/common/searches/api-search.service';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-search-record',
  templateUrl: './search-record.component.html',
  styleUrls: ['./search-record.component.css']
})
export class SearchRecordComponent implements OnInit {
  constructor(private api: ApiService, private toast: ToastrService, private modal: NgbModal) { }
  ngOnInit(): void {
    this.keyUpSubject
      .pipe(debounceTime(800)) // Establece un tiempo de espera de 500 ms (ajústalo según tus necesidades)
      .subscribe((search) => {
        this.getClientByRut(search);
      });
  }
  @Output()
  success = new EventEmitter<boolean>();

  @Output()
  selected = new EventEmitter<Reservations>();
  modalRef: NgbModalRef;

  form = new UntypedFormGroup({
    clients_id: new UntypedFormControl(),
    reservations_id: new UntypedFormControl(),
    rut: new UntypedFormControl(''),
    name: new UntypedFormControl({ value: '', disabled: true }),
    lastname: new UntypedFormControl({ value: '', disabled: true }),
  });
  private keyUpSubject = new Subject<string>();
  modalOtherRef: any;
  contact: Clients;
  client: Clients;
  reservations: Reservations[];
  search() {

  }
  onFormatRut(value: any) {
    let rut = value.target.value;
    if (rut.length > 8) {
      rut = formatRut(rut, RutFormat.DOTS_DASH)
      this.form
        .get('rut')
        ?.setValue(rut);
      this.keyUpSubject.next(rut);
    } else {
      this.keyUpSubject.next(rut);
    }
  }
  getClientByRut(rut: string) {
    this.api.searchClientByRut(rut).subscribe((res) => {
      let clie = res.data as Clients[];
      this.client = clie[0];
      this.form.patchValue(this.client);
      this.form.get('clients_id').setValue(this.client?.id);
      this.getReservations(rut);
    }, (e) => {
      this.toast.info("Cliente no encontrado, reintente");
      this.client = null;
    });
  }

  getReservations(rut: string) {

  }
onSelected(){
  let reserv=this.reservations.find(res=>res.id===this.form.get('reservations_id')?.value);
  this.selected.emit(reserv);
  //this.modal.dismissAll();
}
}


